<div class="container pass-detail-page">
    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <div *ngIf="loaded && notFound" class="not-found">
        <i class="fa-light fa-circle-exclamation fa-3x"></i>
        <h2>Abono no encontrado</h2>
        <p>El abono que buscas no existe o no está disponible.</p>
        <button class="primary-button solid" (click)="goBack()">Ver abonos disponibles</button>
    </div>

    <div *ngIf="loaded && !notFound && pass" class="pass-content">
        <div class="flex-continue-back" (click)="goBack()">
            <i class="fa-light fa-arrow-left"></i>
            <p class="m-0">Volver a abonos</p>
        </div>

        <div class="pass-header">
            <h1 class="pass-title">{{ pass.name }}</h1>
            <div class="pass-discount-badge">
                <i class="fa-light fa-tag"></i>
                <span>{{ getDiscountBadge() }}</span>
            </div>
        </div>

        <!-- Precio fijo: lo que cuesta el abono entero en cada zona -->
        <div class="events-section" *ngIf="isFixedPrices && fixedTotalsByLevel.length > 0">
            <h2 class="section-title">Precio del abono por zona</h2>
            <div class="fixed-levels">
                <div class="fixed-level-row" *ngFor="let row of fixedTotalsByLevel">
                    <span>{{ row.name }}</span>
                    <span class="fixed-level-price">{{ row.total | number:'1.2-2' }}€</span>
                </div>
            </div>
            <p class="fixed-levels-hint">Puedes elegir una zona distinta en cada evento: cada entrada se cobra al precio de la suya.</p>
        </div>

        <div class="events-section">
            <h2 class="section-title">Eventos incluidos</h2>
            <div class="events-list">
                <div class="event-item" *ngFor="let event of pass.events">
                    <div class="event-image">
                        <img fallimg [src]="urlImages + event.image_url" alt="{{ event.title }}">
                    </div>
                    <div class="event-info">
                        <h3 class="event-title">{{ event.title }}</h3>
                        <div class="event-date" *ngIf="event.sessions?.length > 0">
                            <i class="fa-light fa-calendar"></i>
                            <span>{{ event.sessions[0].start_date | date:'EEEE, dd MMM yyyy':'UTC' | titlecase }}</span>
                        </div>
                        <div class="event-prices" *ngIf="isFixedPrices && getFixedEventFrom(event) != null">
                            <span class="bond-price">Desde {{ getFixedEventFrom(event) | number:'1.2-2' }}€</span>
                        </div>
                        <div class="event-prices" *ngIf="!isFixedPrices && getBondTicket(event) as bondTicket">
                            <span class="original-price" *ngIf="getOriginalPrice(event) as origPrice">
                                {{ origPrice | number:'1.2-2' }}€
                            </span>
                            <span class="bond-price">{{ bondTicket.price | number:'1.2-2' }}€</span>
                        </div>
                        <div class="event-map-indicator" *ngIf="hasMap(event)">
                            <i class="fa-light fa-map"></i>
                            <span>Selecciona tu asiento</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pass-action">
            <p class="pass-unavailable" *ngIf="unavailableMessage">
                <i class="fa-light fa-circle-exclamation"></i>
                {{ unavailableMessage }}
            </p>
            <button class="primary-button solid btn-buy" *ngIf="!unavailableMessage" (click)="startPurchase()">
                Comprar abono
            </button>
        </div>
    </div>
</div>
